$(document).ready(function(){
    if($(window).width() < 500){
        if($('.next-to-carousel-banners .banner-wrapper').length > 5){
            $(".next-to-carousel-banners").addClass("not-all");
            $("<div class='show-more'>" + shopDataLayer.banners.help.showMore + "</div>").appendTo(".next-to-carousel-banners");

            $(".next-to-carousel-banners .show-more").on("click", function(){
                $(this).closest(".next-to-carousel-banners").removeClass("not-all");
            });
        }
    }
})